import {
	adminClient,
	inferAdditionalFields,
	magicLinkClient,
	oneTapClient,
	organizationClient,
	passkeyClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import type { auth } from ".";

export const authClient = createAuthClient({
	plugins: [
		inferAdditionalFields<typeof auth>(),
		magicLinkClient(),
		organizationClient(),
		adminClient(),
		passkeyClient(),
		oneTapClient({
			clientId:
				process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID ||
				"1059192956774-aeah4bolb8bpbmlnk89chjuj7s6tvhgq.apps.googleusercontent.com",
			additionalOptions: {
				use_fedcm_for_prompt: true,
			},
			promptOptions: {
				maxAttempts: 0,
			},
		}),
	],
});

export type AuthClientErrorCodes = typeof authClient.$ERROR_CODES & {
	INVALID_INVITATION: string;
	DISPOSABLE_EMAIL_NOT_ALLOWED: string;
	CAPTCHA_VERIFICATION_FAILED: string;
};
